import { render, staticRenderFns } from "./statistics-table.vue?vue&type=template&id=4d7fe4f1&"
import script from "./statistics-table.vue?vue&type=script&lang=js&"
export * from "./statistics-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports